import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_b2be58cc from '../styles/IconContent.module.less.js';

const IconContent = (props) => {
    const { src, children, objectFit, icon } = props;
    const cx = useStyles(modules_b2be58cc);
    if (src) {
        return React.createElement("img", { className: cx('image'), style: { objectFit }, src: src, alt: "icon", loading: "lazy" });
    }
    if (children) {
        return children;
    }
    return icon;
};

export { IconContent };
//# sourceMappingURL=IconContent.js.map
